import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import apiClient from '@/api/client';

import imageOne from '../../resource/events/annualceremony/spnsering-katina/2.png';
import imageFive from '../../resource/events/annualceremony/spnsering-katina/4.png';
import imageThree from '../../resource/events/annualceremony/spnsering-katina/1.png';

const SponseringKatina = () => {
  const navigate = useNavigate();
  const [sponsorData, setSponsorData] = useState([]);

  useEffect(() => {
    const fetchSponsorData = async () => {
      try {
        const response = await apiClient.get('/get-katina-ceremony-requests');
        const data = response.data;
        if (data && Array.isArray(data.data)) {
          setSponsorData(data.data);
        }
      } catch (error) {
        console.error('Error fetching sponsor data:', error);
      }
    };

    fetchSponsorData();
  }, []);

  const handleClick = (event) => {
    const pathMap = {
      katinaRequest: '/katinaRequest',
    };

    const path = event.currentTarget.id;
    const targetPath = pathMap[path];

    if (targetPath) {
      navigate(targetPath);
    }
  };

  // Helper function to get full name
  const getFullName = (first, last) => {
    if (!first && !last) return '';
    return `${first || ''} ${last || ''}`.trim();
  };

  return (
    <div className="indivdualpooja-page inside-pages">
      <div className="right-box">
        <img src={imageOne} alt="Right Top" className="right-image" width={300} />
      </div>

      <h1 className='font-main p-4 mt-4'>Sponsoring Kathina Ceremony</h1>

      <p className='h4 p-4 mt-4 text-center'>Invitation to you..........</p>

      <div className="poem-1 mt-6 h4 font-gold p-4">
        <p>Before the Vassa, ensure the Centre is livable,</p>
        <p>At the start of Vassa, we invite our Sangha,</p>
        <p>Throughout the Vassa, care for them with tenderness,</p>
        <p>At the end of Vassa, offer the "Chivara Katina."</p>
        <p>Vassa is the time for "Dana, Sila, Bhavana."</p>
        <p>Together with the Sangha, we cultivate virtue,</p>
        <p>Select a Vassa, and let it brighten the light of wisdom.</p>
      </div>

      <table className='katina-req mt-6'>
        <thead>
          <tr>
            <th className='font-second'>Year</th>
            <th className='font-second'>Sponsor Name</th>
          </tr>
        </thead>
        <tbody className='h4 text-center'>
          {[...Array(10)].map((_, index) => {
            const year = new Date().getFullYear() + index;
            const sponsorForYear = sponsorData.find(
              (item) => item.year == year && item.status === "Approved"
            );

            return (
              <tr key={year}>
                <td>{year}</td>
                <td>{sponsorForYear ? getFullName(sponsorForYear.first_name, sponsorForYear.last_name) : 'Available'}</td>
              </tr>
            );
          })}
        </tbody>
      </table>

      <div className='btn-group-flex mt-6'>
        <img
          src={imageFive}
          alt="Right Top Image"
          width={300}
          id='katinaRequest'
          onClick={handleClick}
          className='curser-pointer'
        />
      </div>

      <div className="p-4 mt-6 text-center">
        <div className="mt-6 calander-box align-item-center">
          <div className="c-details text-left">
            <h2 className='intro-text '>Further More Details:</h2>
            <p className="font-p mt-4">Monastery: 035608 0918 / 0459 729 738</p>
            <p className="font-p">Mr Gamini: 0422 069 359</p>
            <p className="font-p">WhatsApp: 0422 069 359</p>
            <p className="font-p">E-mail: info@bvp.org.au</p>
          </div>
        </div>
      </div>

      <div className="bottom-box mt-6">
        <img src={imageThree} alt="bottom-image" width={600} />
      </div>
    </div>
  );
};

export default SponseringKatina;
